import { createApp } from 'vue'
import {createAppRouter} from './router'
import './style.css'
import App from './App.vue'

const router = createAppRouter()

createApp(App).use(router).mount('#app')
